import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.concat.js";
export var constant = {
  prefixClass: 'sw'
};
export var Common = /*#__PURE__*/function () {
  function Common() {
    _classCallCheck(this, Common);
  }

  _createClass(Common, null, [{
    key: "getPrefixClass",
    value: function getPrefixClass(content) {
      return constant.prefixClass ? "".concat(constant.prefixClass, "-").concat(content) : content;
    }
  }]);

  return Common;
}();